import { CONTACT } from "../../data/constans";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { motion, Variants } from "framer-motion";

const Contact = () => {
  const containerHorizontal = (startingPosition: number, delay: number): Variants => ({
    initial: { x: startingPosition, opacity: 0 },
    whileInView: { x: 0, opacity: 1, transition: { duration: 0.5, delay: delay } },
  });
  const containerVertical = (startingPosition: number, delay: number): Variants => ({
    initial: { y: startingPosition, opacity: 0 },
    whileInView: { y: 0, opacity: 1, transition: { duration: 0.5, delay: delay } },
  });
  return (
    <div id="contact" className="bg-white">
      <div className="mx-auto w-[90%] p-6 lg:w-[80%]">
        <div className="flex flex-col items-center justify-center">
          <motion.h2
            variants={containerHorizontal(-10, 0.5)}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true }}
            className="mb-6 w-full text-center text-3xl font-extrabold text-blue-500 md:text-4xl lg:text-5xl xl:text-6xl"
          >
            Kapcsolat
          </motion.h2>
          <ul className="flex w-full flex-col items-center space-y-3 md:justify-evenly lg:flex-row lg:space-y-0">
            {/* Mobile */}
            <motion.li
              variants={containerHorizontal(10, 1)}
              initial="initial"
              whileInView="whileInView"
              viewport={{ once: true }}
              className="flex w-full items-center justify-center space-x-2 lg:order-1"
            >
              <FaPhoneAlt className="text-xl text-blue-500" />
              <span className="font-light text-blue-500 md:text-lg">{CONTACT.mobile}</span>
            </motion.li>
            {/* Email */}
            <motion.li
              variants={containerHorizontal(10, 1)}
              initial="initial"
              whileInView="whileInView"
              viewport={{ once: true }}
              className="flex w-full items-center justify-center space-x-2 lg:order-3"
            >
              <FaEnvelope className="text-xl text-blue-500" />
              <span className="font-light text-blue-500 md:text-lg">{CONTACT.email}</span>
            </motion.li>
            {/* Address */}
            <motion.li
              variants={containerHorizontal(10, 1)}
              initial="initial"
              whileInView="whileInView"
              viewport={{ once: true }}
              className="flex w-full items-center justify-center space-x-2 lg:order-2"
            >
              <FaMapMarkerAlt className="text-xl text-blue-500" />
              <div className="flex flex-col items-center justify-center">
                <div className="text-center font-light text-blue-500 md:text-lg">{CONTACT.address1}</div>
                <div className="text-center font-light text-blue-500 md:text-lg">{CONTACT.address2}</div>
              </div>
            </motion.li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Contact;
